import { render, staticRenderFns } from "./IconSvgCross.vue?vue&type=template&id=522de9d5&scoped=true&"
import script from "./IconSvgCross.vue?vue&type=script&lang=js&"
export * from "./IconSvgCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522de9d5",
  null
  
)

export default component.exports